import settings from '../virtuoso/settings';
import ApiUtils from '../virtuoso/ApiUtils';
import LiferayApiUtils from '../liferay/ApiUtils';
import LiferaySettings from '../liferay/settings';
import {RdfsLabelRequest, PredicatSubjectRequest, CountSubjectRequest,
    DCTermsDescriptionRequest,
    SelectRangeInPropertyRequest, SelectPropertyByDomainRequest,
    InsertTripleUriRequest, InsertTripleLiteralRequest, InsertTripleLiteralLangRequest, 
    DeletePredicateRequest, DeleteTripleUriRequest, DeleteTripleLiteralRequest, DeleteTripleLiteralLangRequest,
    UpdateLiteralSimplePropertyRequest, RdfTypeCountRequest,
    SubjectPredicatRequest, SubjectPredicatCountRequest,
    RdfTypesRequest, SelectAllPopertyRequest,
    SKSAOntologRequest, ClassTreeRequest, PropertyTreeRequest,
    TreeElementDetailsRequest, SubjectRDFRequest,
    ExportSubjectRequest, AnySPARQLRequest, 
    PredicatSubject2Request } from '../virtuoso/request';
import { makeWhereFilterAdv } from '../virtuoso/filter';
import { getCountValue2 } from '../virtuoso/helper';

/** Специальные действия для получения информации об онтологии
 * Например, наименование свойств
 */
export const OwlRepository = {
    EMPTY: () => ({
        type: "OwlRepository.EMPTY"
    }),
    LOAD_STARTED: () => ({
        type: "OwlRepository.LOAD_STARTED"
    }),
    LOAD_ERROR: (error) => ({
        type: "OwlRepository.LOAD_ERROR",
        error,
    }),
    LOAD_LABELS: (graph, iri, values) => ({
        type: "OwlRepository.LOAD_LABELS",
        graph, iri, values
    }),
    LOAD_DESCRIPTIONS: (graph, iri, values) => ({
        type: "OwlRepository.LOAD_DESCRIPTIONS",
        graph, iri, values
    }),
    LOAD_CLASS_TREE: (graph, head, distinct, ordered, bindings) => ({
        type: "OwlRepository.LOAD_CLASS_TREE",
        graph, head, distinct, ordered, bindings
    }),
    LOAD_PROPERTY_TREE: (graph, head, distinct, ordered, bindings) => ({
        type: "OwlRepository.LOAD_PROPERTY_TREE",
        graph, head, distinct, ordered, bindings
    }),
    LOAD_TREE_ELEMENT_DETAILS: (graph, iri, head, distinct, ordered, bindings) => ({
        type: "OwlRepository.LOAD_TREE_ELEMENT_DETAILS",
        graph, iri, head, distinct, ordered, bindings
    }),
    SELECT_TREE_ELEMENT: (iri) => ({
        type: "OwlRepository.SELECT_TREE_ELEMENT",
        iri
    }),

    /** Загрузить информацию о метках  */
    loadLabels: (iri, lang, graph) => dispatch => {
        const options = {...settings.options};
        RdfsLabelRequest.setURI(iri);
        return ApiUtils.query(RdfsLabelRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(OwlRepository.LOAD_LABELS(graph, iri, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить информацию об описаниии значение для предиката http://purl.org/dc/terms/description  */
    loadDescription: (iri, graph) => dispatch => {
        const options = {...settings.options};
        DCTermsDescriptionRequest.setURI(iri);
        return ApiUtils.query(DCTermsDescriptionRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(OwlRepository.LOAD_DESCRIPTIONS(graph, iri, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },
    /** Загрузить информацию о таксономии каталога. Является вспомогательной частью описания каталога.
     * Отслеживать процесс загрузки нет необходимости, так как требуется только для фильтрации в UI. */
    loadThemeTaxonomy: () => dispatch => {
        const options = {...settings.options};
        admsAssets.request.offset = 0;
        admsAssets.request.limit = settings.defaultLimit;
        return ApiUtils.query(admsThemeTaxonomy, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_THEMETAXONOMY(bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Получить информацию о http://www.w3.org/2000/01/rdf-schema#range для свойства
     * Используется для получения типов, которые могут быть связаны с объетным свойством */
    loadRange: (predicat) => dispatch => {
        const options = {...settings.options};        
        SelectRangeInPropertyRequest.setProperty(predicat);
        //console.log("OwlActions.js loadRange", subject, predicat, oldValue, newValue, UpdateLiteralSimplePropertyRequest);
        return ApiUtils.query(SelectRangeInPropertyRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                //console.log("OwlActions.js loadRange", subject, predicat, oldValue, newValue, UpdateLiteralSimplePropertyRequest.request, response);
                return Promise.resolve({subject: predicat, range: 'http://www.w3.org/2000/01/rdf-schema#range', types: bindings});
            })
            .catch(e => { 
                //console.log("OwlActions.js loadRange", e);
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Получить информацию о свойствах у которых задан http://www.w3.org/2000/01/rdf-schema#domain 
     * Используется для получения списка свойств, которые могут быть связаны с заданным доменом*/
    loadDomain: (domain) => dispatch => {
        const options = {...settings.options};        
        SelectPropertyByDomainRequest.setDomain(domain);
        //console.log("OwlActions.js loadDomain", domain, Selec1tPropertyByDomainRequest);
        return ApiUtils.query(SelectPropertyByDomainRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                //console.log("OwlActions.js loadRange", domain, Selec1tPropertyByDomainRequest.request, response);
                return Promise.resolve({domain, predicates: bindings});
            })
            .catch(e => { 
                //console.log("OwlActions.js loadDomain", e);
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Получить информацию о всех свойствах */
    loadAllProperties: () => dispatch => {
        const options = {...settings.options};        
        return ApiUtils.query(SelectAllPopertyRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                //console.log("OwlActions.js loadRange", domain, Selec1tPropertyByDomainRequest.request, response);
                return Promise.resolve({predicates: bindings});
            })
            .catch(e => { 
                //console.log("OwlActions.js loadDomain", e);
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Получить дерево классов онтологии */
    loadClassTree: () => dispatch => {
        const options = {...settings.options};
        dispatch(OwlRepository.LOAD_STARTED());
        return ApiUtils.query(ClassTreeRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(OwlRepository.LOAD_CLASS_TREE(ClassTreeRequest.graph, head, distinct, ordered, bindings));
                return Promise.resolve({graph: ClassTreeRequest.graph, head, distinct, ordered, bindings});
            })
            .catch(e => {
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Получить дерево свойств онтологии */
    loadPropertyTree: () => dispatch => {
        const options = {...settings.options};
        dispatch(OwlRepository.LOAD_STARTED());
        return ApiUtils.query(PropertyTreeRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(OwlRepository.LOAD_PROPERTY_TREE(PropertyTreeRequest.graph, head, distinct, ordered, bindings));
                return Promise.resolve({graph: PropertyTreeRequest.graph, head, distinct, ordered, bindings});
            })
            .catch(e => {
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Получить деревья классов и свойств онтологии */
    loadTrees: () => dispatch => {
        dispatch(OwlRepository.LOAD_STARTED());
        return Promise.all([
            dispatch(OwlRepository.loadClassTree()),
            dispatch(OwlRepository.loadPropertyTree())
        ]);
    },

    /** Получить полную информацию о выбранном элементе дерева */
    loadTreeElementDetails: (iri) => dispatch => {
        const options = {...settings.options};
        TreeElementDetailsRequest.setIRI(iri);
        dispatch(OwlRepository.LOAD_STARTED());
        return ApiUtils.query(TreeElementDetailsRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(OwlRepository.LOAD_TREE_ELEMENT_DETAILS(TreeElementDetailsRequest.graph, iri, head, distinct, ordered, bindings));
                return Promise.resolve({graph: TreeElementDetailsRequest.graph, iri, head, distinct, ordered, bindings});
            })
            .catch(e => {
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },
  
    
    loadRdfTypes: (subjectIri) => dispatch => {  
        const options = {...settings.options};        
        RdfTypesRequest.setIRI(subjectIri);
        return ApiUtils.query(RdfTypesRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({subjectIri, types: bindings});
            })
            .catch(e => { 
                //console.log("OwlActions.js loadDomain", e);
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Выполнение запроса CONSTRUCT для получения онтологии SKSA в графе*/
    loadOntology: () => dispatch => {  
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_construct':{}}),
          'default_graph_uri': SKSAOntologRequest.graph,
          'output_format': 'TTL',
          'query': SKSAOntologRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options)            
          .then ((response) =>{
            return Promise.resolve(response);
          })
          .catch(e => { 
            console.log("OwlActions.js loadOntology", e);
            dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
            //Нельзя reject что-бы не прерывать цепочку визово
            return Promise.resolve(null);
          });
    },
        
};

export const RdfTriplet = {
    EMPTY: () => ({
        type: "RdfTriplet.EMPTY"
    }),
    ACTION_STARTED: () => ({
        type: "RdfTriplet.ACTION_STARTED"
    }),
    ERROR: (error) => ({
        type: "RdfTriplet.ERROR",
        error,
    }),
    SELECTED: (operation, subject, predicat, value) => ({
        type: "RdfTriplet.SELECTED",
        operation, subject, predicat, value
    }),
    UPDATE: (graph, iri, values) => ({
        type: "RdfTriplet.UPDATE",
        graph, iri, values
    }),

    /** Загрузить информацию о субъекте миную jena. subject - iri субъекта. Возвращает триплеты */
    loadSubject: (subject, graph) => {
        PredicatSubjectRequest.setIRI(subject);
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_select':{}}),
          'default_graph_uri': PredicatSubjectRequest.graph,
          'query': PredicatSubjectRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options)            
            .then ((response) =>{
                const data = typeof response === "string" ? JSON.parse(response) : response;
                const {head, results} = data;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({subject, graph, head, distinct, ordered, bindings});
            })
            .catch(e => {             
                dispatch(ServiceRepository.LOAD_ERROR(`Ошибка при получении IRI для PURL мапинга ${e}.`));
                return Promise.reject(e);
            });
    }, 

    /** Загрузить информацию о субъекте. subject - iri субъекта. Возвращает триплеты */
    loadSubject2: (subject, graph) => {
        const options = {...settings.options};
        PredicatSubjectRequest.setIRI(subject);
        return ApiUtils.query(PredicatSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({subject, graph, head, distinct, ordered, bindings});
            });
    }, 

    /** Загрузить информацию об объекте. object - iri объекта. Возвращает триплеты */
    loadObject: (object, graph) => {
        const options = {...settings.options};
        SubjectPredicatRequest.setIRI(object);
        return ApiUtils.query(SubjectPredicatRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({object, graph, head, distinct, ordered, bindings});
            });        
    },

    update: (iri, graph) => dispatch => {
        const options = {...settings.options};
        rdfsLabel.setURI(iri);
        return ApiUtils.query(rdfsLabel, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(OwlRepository.LOAD_LABELS(graph, iri, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(OwlRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    countSubject: (subject, graph) => {
        const options = {...settings.options};
        //console.log(CountSubjectRequest.request);
        CountSubjectRequest.setIRI(subject);
        //console.log(CountSubjectRequest.request);
        return ApiUtils.query(CountSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({subject, graph, head, distinct, ordered, bindings});
            });        
    },

    insertTripleURI: (subject, predicat, uri) => dispatch => {
        InsertTripleUriRequest.setValues(subject, predicat, uri);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri':InsertTripleUriRequest.graph,
            'query': InsertTripleUriRequest.sparql,
          }
        //console.log("OwlActions.js insertTripleURI", subject, predicat, uri, InsertTripleUriRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("OwlActions.js insertTripleURI", subject, predicat, uri, InsertTripleUriRequest.request, response);
                return Promise.resolve({subject, predicat, uri});
            })
            .catch(e => { 
                console.log("OwlActions.js insertTripleURI", e);
                dispatch(RdfTriplet.ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    insertTripleLiteral: (subject, predicat, object, lang = undefined) => dispatch => {
        //console.log("OwlActions.js insertTripleLiteral", subject, predicat, object, lang);
        if (lang)
            InsertTripleLiteralLangRequest.setValues(subject, predicat, object, lang);
        else
            InsertTripleLiteralRequest.setValues(subject, predicat, object);
        const request = (lang) ? InsertTripleLiteralLangRequest : InsertTripleLiteralRequest;
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri':request.graph,
            'query': request.sparql,
          }
        //console.log("OwlActions.js insertTripleLiteral", request);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("OwlActions.js insertTripleURI", subject, predicat, uri, InsertTripleUriRequest.request, response);
                return Promise.resolve({subject, predicat, object, lang});
            })
            .catch(e => { 
                console.log("OwlActions.js insertTripleLiteral", e);
                dispatch(RdfTriplet.ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    deletePredicate: (subject, predicat) => dispatch => {
        DeletePredicateRequest.setValues(subject, predicat);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri':DeletePredicateRequest.graph,
            'query': DeletePredicateRequest.sparql,
          }
        //console.log("OwlActions.js deleteTripleUri", subject, predicat, uri, DeleteTripleUriRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({subject, predicat});
            })
            .catch(e => { 
                console.log("OwlActions.js deletePredicate", e);
                dispatch(RdfTriplet.ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    deleteTripleURI: (subject, predicat, uri) => dispatch => {
        DeleteTripleUriRequest.setValues(subject, predicat, uri);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri':DeleteTripleUriRequest.graph,
            'query': DeleteTripleUriRequest.sparql,
          }
        //console.log("OwlActions.js deleteTripleUri", subject, predicat, uri, DeleteTripleUriRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("OwlActions.js deleteTripleUri", subject, predicat, uri, DeleteTripleUriRequest.request, response);
                return Promise.resolve({subject, predicat, uri});
            })
            .catch(e => { 
                console.log("OwlActions.js deleteTripleUri", e);
                dispatch(RdfTriplet.ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    deleteTripleLiteral: (subject, predicat, object, lang = undefined) => dispatch => {
        console.log("OwlActions.js deleteTripleLiteral", subject, predicat, object, lang);
        if (lang)
            DeleteTripleLiteralLangRequest.setValues(subject, predicat, object, lang);
        else
            DeleteTripleLiteralRequest.setValues(subject, predicat, object);
        const request = (lang) ? DeleteTripleLiteralLangRequest : DeleteTripleLiteralRequest;
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri':request.graph,
            'query': request.sparql,
          }
        //console.log("OwlActions.js deleteTripleLiteral", subject, predicat, uri, DeleteTripleUriRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("OwlActions.js deleteTripleUri", subject, predicat, uri, DeleteTripleUriRequest.request, response);
                return Promise.resolve({subject, predicat, object, lang});
            })
            .catch(e => { 
                console.log("OwlActions.js deleteTripleLiteral", e);
                dispatch(RdfTriplet.ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });        
    },
    

    updateLiteralSimple:(subject, predicat, oldValue, newValue) => dispatch => {
        console.log("OwlActions.js updateLiteralSimple", subject, predicat, oldValue, newValue, UpdateLiteralSimplePropertyRequest);
        UpdateLiteralSimplePropertyRequest.setValues(subject, predicat, oldValue, newValue);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri':UpdateLiteralSimplePropertyRequest.graph,
            'query': UpdateLiteralSimplePropertyRequest.sparql,
          }
        console.log("OwlActions.js updateLiteralSimple", subject, predicat, oldValue, newValue, UpdateLiteralSimplePropertyRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("OwlActions.js updateLiteralSimple", subject, predicat, oldValue, newValue, UpdateLiteralSimplePropertyRequest.request, response);
                return Promise.resolve({subject, predicat, oldValue, newValue});
            })
            .catch(e => { 
                console.log("OwlActions.js updateLiteralSimple", e);
                dispatch(RdfTriplet.ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузка количества доступных элементов по типу. Заполняет vadms.statistics */
    loadRdfTypeCount: (rdfType, conditions=[]) => dispatch => {
        const options = {...settings.options};
        const request = RdfTypeCountRequest;
        request.setRdfType(rdfType);
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                const count =(Array.isArray(bindings) && (bindings.length>0))?bindings[0].cnt.value: 0;
                //dispatch(AdmsRepository.STATISTICS(rdfType, {count}));
                return Promise.resolve({rdfType, count, response});
            })
            .catch(e => { 
                dispatch(RdfTriplet.ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },
};

/** Проверяет, что есть назначенный условия */
const isConditionPresent = (conditions, rfilter) => {
    return (Array.isArray(conditions) && conditions.length>0) || (Array.isArray(rfilter) && rfilter.length>0);
}
/** Формирует запрос с учётом наличия условий. Если условяи есть, то делается cloneOriginal() 
 * и добавляются условия! */
const makeRequest = (pattern, conditions, rfilter) => {
    if (!isConditionPresent(conditions, rfilter))
        return pattern;
    const request = pattern.cloneOriginal();
    makeWhereFilterAdv(request, [...conditions.map(a => ({...a})), ...rfilter.map(a => ({...a}))], true);
    return request;
}

/** Выполняет операции получения списка субъектов */
export const SubjectRepository = {
    //Значение обязательного фильтра
    RFILTER: [],
    EMPTY: () => ({
        type: "SubjectRepository.EMPTY",
    }),
    SET_RFILTER: rfilter => {
        AdmsRepository.RFILTER = rfilter;
        return ({
            type: "SubjectRepository.SET_RFILTER", 
            rfilter
        })
    },
    LOAD_STARTED: () => ({
        type: "SubjectRepository.LOAD_STARTED",
    }),
    LOAD_ERROR: (error) => ({
        type: "SubjectRepository.LOAD_ERROR",
        error
    }),
    LOAD_DESCRIPTION: (IRI, description) => ({
        type: "SubjectRepository.LOAD_DESCRIPTION",
        IRI, description
    }),
    LOAD_DETAILS: (iri, head, values) => ({
        type: "SubjectRepository.LOAD_DETAILS",
        iri, values, head,
        predicates : (values && Array.isArray(values))?[...new Set(values.map(item => item.predicat.value))]:[], 
        languages: (values && Array.isArray(values))?[...new Set(values.map(item => item.object["xml:lang"]))]:[]
    }),
    LOAD_SUBJECTS: (offset, limit, count, head, distinct, ordered, subjects) => ({
        type: "SubjectRepository.LOAD_SUBJECTS",
        offset, limit, count, head, distinct, ordered, subjects
    }),
    LOAD_NEXTSUBJECTS: (offset, limit, head, distinct, ordered, subjects) => ({
        type: "SubjectRepository.LOAD_NEXTSUBJECTS",
        offset, limit, head, distinct, ordered, subjects
    }),

    /** Загрузить информацию о субъектах в список. 
     * iriObject - iri объекта, для которого ищутся субъекта
     * conditions - условия отбора,  
     * rfilter - обязательные условия отбора. При загрузке дополнительно загружается 
     * количество субъектов */
    loadSubjects: (iri, conditions=[], rfilter=SubjectRepository.RFILTER) => dispatch => {
        dispatch(SubjectRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(SubjectPredicatRequest.cloneOriginal(), conditions, rfilter);
        request.setIRI(iri);
        request.request.offset = 0;
        request.request.limit = settings.defaultLimit;
        //console.log("AdmsActions.js loadAssets: (conditions=[], rfilter=[]) => dispatch => {", request);
        const counter = makeRequest(SubjectPredicatCountRequest.cloneOriginal(), conditions, rfilter);
        counter.setIRI(iri);
        return Promise.all([
                ApiUtils.query(request, {}, options),
                ApiUtils.query(counter, {}, options),
            ]).then ((response) =>{
                const {head, results} = response[0];
                const {distinct, ordered, bindings} = results;
                const count = getCountValue2(response[1].results.bindings, -1);
                dispatch(SubjectRepository.LOAD_SUBJECTS(0, request.request.limit, count, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SubjectRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить следующую порцию информации о субъектах */
    loadNextSubjects: (iri, offset, conditions=[], rfilter=SubjectRepository.RFILTER) => dispatch => {
        dispatch(SubjectRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(SubjectPredicatRequest.cloneOriginal(), conditions, rfilter);
        request.setIRI(iri);
        request.request.offset = offset;
        request.request.limit = settings.defaultLimit;
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(SubjectRepository.LOAD_NEXTSUBJECTS(offset, request.request.limit, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(SubjectRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Выполнение запроса CONSTRUCT для получения RDF из графа */
    loadTTL: (subject) => {  
        const options = {...LiferaySettings.options};
        SubjectRDFRequest.setIRI(subject);
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_construct':{}}),
          'default_graph_uri': SubjectRDFRequest.graph,
          'output_format': 'TTL',
          'query': SubjectRDFRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options)            
          .then ((response) =>{
            return Promise.resolve(response);
          })
          .catch(e => { 
            console.log("OwlActions.js loadTTL", e);
            return Promise.reject(null);
          });
    },

    /** Выполнение запроса CONSTRUCT для получения триплетов по набору URI. */
    exportSubject: (graph, IRIs, outputFormat = 'N-TRIPLE') => {
        // const request = AnySPARQLRequest.cloneOriginal();
        // request.setSparql(buildExportAsset_sparql(IRIs));

        ExportSubjectRequest.setIRIs(IRIs);        
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_construct':{}}),
            'default_graph_uri': graph,
            'output_format': outputFormat,
            'query': ExportSubjectRequest.sparql,
            // 'query': request.sparql, 
        }
        return LiferayApiUtils.postToLifeRay721(formData, options);
    },
    
    
};

/** Служебные  */
export const GraphExchangeRepository = { 

    /** Выполняет экспорт из graph все триплеты субъектов заданых в IRIs
     *  Реализуется выполнением SPARQL запроса CONSTRUCT. Получает данные в формате N-TRIPLE
     *  <subject> <predicate> <object>
    */
    exportSubjects: (graph, IRIs) => {
        ExportSubjectRequest.setIRIs(IRIs);        
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_construct':{}}),
            'default_graph_uri': graph,
            'output_format': 'N-TRIPLE',
            'query': ExportSubjectRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options);
    },

    /** Выполняет импорт в graph. Данные для импорта задаются в sparql 
     * 
     *  Реализуется выполнением SPARQL запроса c операторами DELETE и INSERT
    */    
    importSubjects: (graph, sparql) => {
        const options = {...settings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': graph,
            'query': sparql,
            }
        return LiferayApiUtils.postToLifeRay721(formData, options);
    },
    
};

/** Специальный акшен, который обрабатывает пустые узал  */
export const BlackNode = {
    /** Загрузить информацию о субъекте миную jena. subject - iri субъекта. Возвращает триплеты */
    loadNode: (subject, graph) => {
        PredicatSubjectRequest.setIRI(subject);
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_select':{}}),
          'default_graph_uri': PredicatSubjectRequest.graph,
          'query': PredicatSubjectRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options)            
            .then ((response) =>{
                const data = typeof response === "string" ? JSON.parse(response) : response;
                const {head, results} = data;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({subject, graph, head, distinct, ordered, bindings});
            });
    }, 
    /** Загрузить информацию о субъекте. subject - iri субъекта. 
     * Возвращает триплеты влючая субъек переменные ?s ?p ?o */
    loadSubject3: (subject, graph) => {
        const options = {...settings.options};
        PredicatSubject2Request.setIRI(subject);
        return ApiUtils.querySelect(PredicatSubject2Request)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({subject, graph, head, distinct, ordered, bindings});
            });
    }, 
};